import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import Resources from '@/views/Resources.vue'
import DownloadView from '@/views/DownloadView.vue'
import UploadView from '@/views/UploadView.vue'
import ContactView from '@/views/ContactView.vue'
import ResDetail from '@/views/ResDetail.vue'
import Payment from '@/views/Payment.vue'
import Agreement from '@/views/Agreement.vue'
import AlipayReturn from '@/views/AlipayReturn.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },

  {
    path: '/res',
    name: 'resouces',
    component: Resources
  },
  
  {
    path: '/res/:id',
    name: 'ResDetail',
    component: ResDetail
  },

  {
    path: '/download',
    name: 'download',
    component: DownloadView
  },

  {
    path: '/upload',
    name: 'upload',
    component: UploadView
  },

  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },

  {
    path: '/pay/:user_id',
    name: 'pay',
    component: Payment
  },

  {
    path: '/agreements',
    name: 'agreements',
    component: Agreement
  },

  {
    path: '/alipayReturn',
    name: 'alipayReturn',
    component: AlipayReturn
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
